import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { homeFor } from "../lib/roles";

export default function ProtectedRoute({ children, ownerOnly = false, roles }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-neutral-400 text-sm">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    const home = homeFor(user.role);
    if (ownerOnly && user.role !== "owner") return <Navigate to={home} replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to={home} replace />;
    return children;
}
